import type { TScoreTypeNames } from '../../models';
import { TOTAL_SCORE_TYPE_NAME } from '../../constants';
export const DESKTOP_WIDTH = 316;
export const DESKTOP_HEIGHT = 227;
export const PENTAGRAM_VERTICAL_CENTER = DESKTOP_HEIGHT / 2 + 5;
export const PENTAGRAM_HORIZONTAL_CENTER = DESKTOP_WIDTH / 2 + 5;
export const PENTAGRAM_VIEW_BOX = `-${PENTAGRAM_HORIZONTAL_CENTER} -${PENTAGRAM_VERTICAL_CENTER} ${DESKTOP_WIDTH} ${DESKTOP_HEIGHT}`;
export const PENTAGRAM_GRID_WIDTH = 2;
export const PENTAGRAM_SCORE_TYPE_NAMES: TScoreTypeNames[] = [
    'potential',
    'history',
    'dividends',
    'stability',
    'fundamentals',
];
export const PENTAGRAM_SCORES_NUMBER = PENTAGRAM_SCORE_TYPE_NAMES.length;
export const PENTAGRAM_TOTAL_SCORE_TYPE_NAME = TOTAL_SCORE_TYPE_NAME;
export const PENTAGRAM_BASE_RADIUS = 74;
export const PENTAGRAM_MIN_NORMAL_SCORE = 5;
export const PENTAGRAM_MAX_NORMAL_SCORE = 7;
export const PENTAGRAM_SCORE_DESCRIPTION_OFFSET_X = 20;
export const PENTAGRAM_SCORE_DESCRIPTION_OFFSET_Y = 30;
export const PENTAGRAM_SCORE_COMMON_OFFSET_X = 0;
export const PENTAGRAM_SCORE_EXTRA_OFFSET_X = 15;
export const PENTAGRAM_MIN_VALUE = 4;
